import React, {Component} from 'react';
import axios from 'axios';
import {Animated} from "react-animated-css";
import Validator from 'email-validator';
import Slider from "react-slick";
import DemoCard from '../../components/DemoCard/DemoCard';
import {
        Container, 
        Row, 
        Col, 
        Card, 
        CardBody, 
        CardFooter, 
        Button, 
        Input, 
        InputGroup, 
        InputGroupAddon, 
        InputGroupText
      } from 'reactstrap';

import firebase, 
    {
        auth,
        PROVIDER_FACEBOOK,
        PROVIDER_GOOGLE        
    } from '../../firebase';

import {
        firebaseLoginErrors,
        FACEBOOK_PROVIDER_ID,
        GOOGLE_PROVIDER_ID
    } from './constants'; 
    
import {
  ADD_LOCATION,
  ERROR_MESSAGES,
  FORGOT_RESPONSE,
  FORGOT_USER,
  LOGIN_USER,
  REGISTER_USER,
  REGISTER_USER_BY_ID,
  CAROUSEL_SETTINGS
} from '../../config';



class Register extends Component {
  constructor(props){
    super(props);
    this.state = {
      forgotPassword: false,
      loggingIn: false,
      error: '',
      email: '',
      p1: '',
      p2: '',
      processing: false
    }

    this._handleKeyPress = this._handleKeyPress.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleP1Change = this.handleP1Change.bind(this);
    this.handleP2Change = this.handleP2Change.bind(this);
  }

  /**
   * Performs request to register user in database
   * via email and password. Retrieves a user token that can be used 
   * @param  email 
   * @param  password 
   */
  registerUser(email, password){
    let self = this;
    auth.createUserWithEmailAndPassword(email, password)
        .then(function(response){
            auth.currentUser.getIdToken(true)
                .then(function(idToken){
                    axios.post(REGISTER_USER_BY_ID(), {
                        "id": idToken
                    })
                    .then(function(result){
                        self.setState({processing: false});
                        self.updateToken(result.data);
                    })
                    .catch(function(error){
                        let errorMessage = (error.response.data && error.response.data.msg) ?
                            error.response.data.msg : firebaseLoginErrors(error.code);

                            self.setState({processing: false, error: errorMessage});
                    });
                })
                .catch(function(error){
                    self.setState({error: firebaseLoginErrors(error.code), processing: false});
                })
        })
        .catch(function(error){
            self.setState({error: firebaseLoginErrors(error.code), processing: false});
        });
  }

  /**
   * Performs request to login user via email and password
   * Retrieves a user token from firebase that is sent to dashboard backend to retrieve
   * local system token
   * @param  email 
   * @param  password 
   */
  loginUser(email, password) {
    let self = this;
    auth.signInWithEmailAndPassword(email, password)
        .then(function(response){
            auth.currentUser.getIdToken(true)
                .then(function(idToken){
                    axios.post(REGISTER_USER_BY_ID(), {
                        "id": idToken
                    })
                    .then(function(result){
                        self.setState({processing: false});
                        self.updateToken(result.data);
                    })
                    .catch(function(error){
                        let errorMessage = (error.response && error.response.data && error.response.data.msg) ? 
                            error.response.data.msg : firebaseLoginErrors(error.code);
                        
                        self.setState({processing: false, error: errorMessage});
                    })
                })
                .catch(function(error){
                    let errorMessage = (error.response && error.response.data && error.response.data.msg) ? 
                        error.response.data.msg : firebaseLoginErrors(error.code);
                
                    self.setState({processing: false, error: errorMessage});
                })
        })
        .catch(function(error){
            self.setState({error: firebaseLoginErrors(error.code), processing: false});            
        });
  }
  
  /**
   * Performs request to login user via Google or Facebook
   * Retrieves a user token that can be used for more requests
   */
  loginWithSocialMedia(providerFlag) {
    let provider = (providerFlag == GOOGLE_PROVIDER_ID) ? PROVIDER_GOOGLE : PROVIDER_FACEBOOK
    let self = this;
    auth.signInWithPopup(provider)
      .then(function (response) {
        auth.currentUser.getIdToken(true)
          .then(function (idToken) {
            axios.post(REGISTER_USER_BY_ID(), {
              "id": idToken
            })
              .then(function (response) {
                self.setState({ processing: false });
                self.updateToken(response.data);
              })
              .catch(function (error) {
                let errorMessage = (error.response && error.response.data && error.response.data.msg) ?
                  error.response.data.msg : firebaseLoginErrors(error.code);

                self.setState({ error: errorMessage, processing: false });
              })
          })
          .catch(function (error) {
            self.setState({ error: ERROR_MESSAGES.SOCIAL_ERROR, processing: false })
          });
      })
      .catch(function (error) {
        let errorMessage = (error.response && error.response.data && error.response.data.msg) ?
          error.response.data.msg : firebaseLoginErrors(error.code);

        self.setState({ error: errorMessage, processing: false });
      });
  }  

  /**
   * Performs request for forgot user via email
   * Retrieves success or failure
   * @param email 
   */
  forgotUser(email){
    let self = this;
    auth.sendPasswordResetEmail(email)
    .then(function(){
      self.setState({processing: false, error: ERROR_MESSAGES.FORGOT_RESPONSE});
    })
    .catch(function(error){
      self.setState({error: ERROR_MESSAGES.INVALID_EMAIL, processing: false});
    });
  }

  
  updateToken(token){
    this.props.updateToken(token);
  }

  toggleLogin(){
    this.setState({loggingIn: !this.state.loggingIn})
  }

  toggleForgot(){
    this.setState({forgotPassword: !this.state.forgotPassword})
  }

  handleEmailChange(event){
    this.setState({email: event.target.value});
  }

  handleP1Change(event){
    this.setState({p1: event.target.value});
  }

  handleP2Change(event){
    this.setState({p2: event.target.value});
  }


   /**
   * Bind enter button to login or signup
   * @param e : event 
   */
  _handleKeyPress(e){
    if(this.processing) return;
    if(e.key === 'Enter'){
      if(this.state.loggingIn) this.login();
      else this.signup();
    }
  }

  /**
   * Validate and retrieve form data for signup user
   */
  signup(){
    if (this.state.processing) return;
    this.setState({processing: true});
    let validEmail = Validator.validate(this.state.email);
    if (!validEmail){
      this.setState({error: ERROR_MESSAGES.INVALID_EMAIL, processing: false});
      return;
    }

    if (!this.state.p1 || !this.state.p2){
      this.setState({error: ERROR_MESSAGES.MISSING_PASSWORD, processing: false});
      return;
    }
    if (this.state.p1 != this.state.p2){
      this.setState({error: ERROR_MESSAGES.PASSWORD_MATCH, processing: false});
      return;
    }
    if (this.state.p1.length < ERROR_MESSAGES.MIN_PASS_LENGTH){
      this.setState({error: ERROR_MESSAGES.PASSWORD_LENGTH, processing: false});
      return;
    }
    this.registerUser(this.state.email.trim(), this.state.p1);
  }

  /**
   * Validate and retrieve form data for login
   */
  login(){
    if (this.state.processing) return;
    this.setState({processing: true});
    if (!this.state.p1 || !this.state.email){
      this.setState({error: ERROR_MESSAGES.MISSING_INFO, processing: false});
      return;
    }
    this.loginUser(this.state.email.trim(), this.state.p1);
  }

  /**
   * Enter forgot user sequence
   */
  forgot(){
      if(this.state.processing) return;
      this.setState({processing: true});
      this.forgotUser(this.state.email);
  }


  /** 
   * Render login card
   */
  renderLoginCard(){
    return(
      <Animated animationIn="flipInY" animationOut="flipInY" isVisible={true}>
      <div className="RegistrationCard">
        <div className="RegistrationCardBody">
          <h5 className="RegistrationCardHeading">
            Login
          </h5>
          <div className="rightSideLink" onClick={ () => this.toggleLogin()}>
            sign up
          </div>
          <Input
            type="text" 
            className="RegistrationCardTextBox" 
            placeholder="email"
            onChange={this.handleEmailChange}
            value = {this.state.email}  
            onKeyPress={this._handleKeyPress}
            />
          <Input type="password" 
            className="RegistrationCardTextBox" 
            placeholder="password"
            onChange={this.handleP1Change}
            value={this.state.p1}
            onKeyPress={this._handleKeyPress} 
            /> 

          <div className="linkInText forgotPass" onClick={() => this.toggleForgot()}> Forgot password? </div>
          <Button 
            className="RegistrationCardButton" 
            color="success"
            disabled={this.state.processing ? true : false}
            onClick={()=> this.login()} 
            block>
                  login
          </Button>
        </div>
      </div>
      </Animated>
    )
  }

  renderError(){
    if(this.state.error != ''){
      if(this.state.error == ERROR_MESSAGES.FORGOT_RESPONSE){
        return(
          <Animated 
          animationIn="shake" 
          animationOut="" 
          isVisible={true}
          test={this.state.forgotPassword}
          >
          <div>
              <div className="RegistrationCard" id="ErrorGreen" >
                <div className="RegistrationCardBody">
                  {this.state.error}
                </div>
              </div>
          </div>
          </Animated>
        )
      }
      else{
        return(
          <div>
            <Animated animationIn="shake" animationOut="" isVisible={true}>
            <div className="RegistrationCard" id="ErrorRed" >
              <div className="RegistrationCardBody">
                {this.state.error}
              </div>
            </div>
            </Animated>
          </div>
        )
      }
    }
  }

  /**
   * Render registration card
   */
  renderRegistrationCard(){
    return(
      <div className="RegistrationCard">
        <div className="RegistrationCardBody">
          <h5 className="RegistrationCardHeading">Register</h5>
          <div className="rightSideLink" onClick={() => this.toggleLogin()}>log in</div>

          <Input 
            type="text"
            className="RegistrationCardTextBox" 
            placeholder="email"
            onChange={this.handleEmailChange}
            value = {this.state.email}
            />
          <Input 
            type="password" 
            className="RegistrationCardTextBox" 
            placeholder="password"
            onChange={this.handleP1Change}
            value={this.state.p1}
            onKeyPress={this._handleKeyPress}
            />
          <Input 
            className="RegistrationCardTextBox" 
            type="password" 
            placeholder="repeat password"
            onChange={this.handleP2Change}
            value={this.state.p2}
            onKeyPress={this._handleKeyPress} 
            />

          <div className="RegistrationCardText">
            By creating an account, you agree to the {" "}
            <a href="https://honeycomb.ai/terms-of-use" target="_blank"> 
              Terms Of Service 
            </a>
          </div>
          <Button 
              className="RegistrationCardButton"
              color="success"
              disabled={this.state.processing ? true : false}
              onClick={()=> this.signup()}
              block>
              create an account
          </Button>
        </div>
      </div>
    )
  }

  /**
   * Render forget password card
   */
  renderForgotPasswordCard(){
    return(
      <Animated animationIn="flipInY" animationOut="flipInY" isVisible={true}>
      <div className="RegistrationCard">
        <div className="RegistrationCardBody">
          <h5 className="RegistrationCardHeading">Forgot Password</h5>
          <Input 
            type="text" 
            className="RegistrationCardTextBox" 
            placeholder="email" 
            onChange={this.handleEmailChange}
            value = {this.state.email}/> 
          <div className="RegistrationCardText">
            Need Help? Use the chat button in the bottom right.
          </div>
          <Button 
            className="RegistrationCardButton" 
            color="success"
            disabled={this.state.processing ? true : false}
            onClick={()=> {
              this.forgot();
              this.toggleForgot();
            }}
            >
            reset password
          </Button>
        </div>
      </div>
      </Animated>
    )
  }

  /**
   * Render schedule a demo card
   */
  renderDemoCard(){
    return(
      <div className="RegistrationCard demoCard">
        <div className="RegistrationCardBody" >
          <div className="callIcon" ><img src="img/call.svg" width="50"></img></div>
        
          <div className="demoText">We'll show you how Honeycomb makes you more money, and makes you and your customers more happy</div>
          <a href="https://calendly.com/tamir-barzilai">
            <button className="RegistrationCardButton">schedule a ten minute demo</button>
          </a>
        </div>
      </div>
    )
  }

  /** 
   * Checks state to see, which card to render
   * login, forgotpassword or register
  */
  checkActiveCard(){
    if(this.state.forgotPassword){
      return (
        
        <Animated animationIn="flipInY" animationOut="flipInY" isVisible={true}>
        {this.renderForgotPasswordCard()}
        </Animated>
      )
    }
    else{
      if(this.state.loggingIn){
        return(
          <Animated animationIn="flipInY" animationOut="flipInY" isVisible={true}>
          {this.renderLoginCard()}
          </Animated>
        )
      }
      else{
        return(
          <Animated animationIn="flipInY" animationOut="flipInY" isVisible={true}>
          {this.renderRegistrationCard()}
          </Animated>
        )
      }
    }
  }


  //Lifecycle Functions

  componentWillMount(){
    let visited = localStorage.getItem("VISITED");
    if(visited) this.setState({loggingIn: true});
    else localStorage.setItem("VISITED",true);
  }

  render() {
    return (
      <div className="home-page">
        <div className="row">
      
          <div className="col">
            <div className="loginInterface">
              <div className="homepageLogo">
                <img src="img/logo-roundedtype.svg" width="325"></img>
              </div>
              {this.renderError()}
              {this.checkActiveCard()}
              <DemoCard id="registerDemoCard"/>
            </div>
          </div>

           <div className="col homepage-mobile">
              <div className="carouselContainer">
                <img src="img/bacground-words.svg"></img>
              </div>
           </div>

        </div>
      </div>
    );
  }

}
export default Register;



// WEBPACK FOOTER //
// ./src/views/Register/Register.js